import { EntityState } from '@ngrx/entity';

export interface IConfigurationsFeatureState extends EntityState<string> {}
